import {gsap} from 'gsap';
import {isMobile, isTablet} from '../components/helpers';
import {initParallaxSection} from '../components/parallax-section';

export function initFactoringLanding() {
    if (!$('#factoring_landing').length) return;
    initParallaxSection();
    initFactoringGadgetsEffects();

    $(window).resize(function () {
        initFactoringGadgetsEffects();
    });
}

function initFactoringGadgetsEffects() {

    const tl = gsap.timeline({
        scrollTrigger: {
            scroller: isMobile() || isTablet() ? '' : '.scroller',
            trigger: '.factoring-phones-block',
            start: 'top-=100% top',
            end: 'bottom top',
            scrub: true
        }
    });

    gsap.utils.toArray('.factoring-phone').forEach(layer => {
        if ($(layer).hasClass('center-phone') || $(window).width() < 761) return;

        const depth = layer.dataset.depth;
        const movement = -($('.factoring-phones-block').height() * depth);
        tl.to(layer, {y: movement, ease: 'none'}, 0)
    });
}
